module.exports = __webpack_public_path__ + "static/img/titile-big.a322939.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/img/titile-big.png
// module id = H9ee
// module chunks = 1